import {
    FETCH_APPOINTMENTDROPDOWN_REQUEST,
    FETCH_APPOINTMENTDROPDOWN_SUCCESS,
    FETCH_APPOINTMENTDROPDOWN_FAILURE,
  } from "./AppointmentTypes";
  import api from "../../utils/Api";
  
  export const fetchAppointmentDropdownRequest = () => {
    return {
      type: FETCH_APPOINTMENTDROPDOWN_REQUEST,
    };
  };
  
  export const fetchAppointmentDropdownSuccess = (appointmentDropdown) => {
    return {
      type: FETCH_APPOINTMENTDROPDOWN_SUCCESS,
      payload: appointmentDropdown,
    };
  };
  
  export const fetchAppointmentDropdownFailure = (error) => {
    return {
      type: FETCH_APPOINTMENTDROPDOWN_FAILURE,
      payload: error,
    };
  };
  
  export const fetchAppointmentDropdown = () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchAppointmentDropdownRequest());
      try {
        const response = await api.get("appointment/initialData/fetch", {
          headers: headers,
        });
        const appointmentDropdown = response.data.data;
        //console.log("****** appointment dropdown response", appointmentDropdown);
        dispatch(fetchAppointmentDropdownSuccess(appointmentDropdown));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchAppointmentDropdownFailure(errorMsg));
      }
    };
  };
  